export default {
  processSteps: 'Process steps',
};
